import React from 'react'
import { useNavigate } from 'react-router-dom'

const CardHomeParam = ({ title, link }) => {
    let navigate = useNavigate()

    return (
        <div className='card shadow border-secondary border-1 bg-light p-2 mx-4 my-3' onClick={() => navigate( link )}>
            <h6 className='card-title text-center text-secondary mt-1 fw-light'>{title}</h6>
        </div>
    )
}

export default CardHomeParam
